import { LegalContents } from '@chegg-wt/core/types/core'

export const legalContents: LegalContents = {
  commitment: '',
  copyright: `© 2007-${new Date().getFullYear()} BibMe™, a Chegg Service.`,
  tagline:
    'BibMe™ formats according to APA 7th Edition, MLA 9th Edition, Chicago 17th Edition',
}
